import { Component } from '@angular/core';

@Component({
  selector: 'oly-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent{
  constructor() {}
}
